module.exports = __webpack_public_path__ + "img/eyd.0a3b31ad.jpg";